module.exports = __webpack_public_path__ + "static/media/uoa-16.f16a58fe.jpg";